import { Injectable } from '@angular/core';

@Injectable()
export class EnvService {

    public baseUrl;
    public apiVersion;
    public patientPathCount;
    public onHotjar;
    public hotJarSiteID;
    public wsUrl;
    public wsKey;
    public wsCluster;
    public wsHost;
    public wsPort;
    public wssPort;
    public httpHost;
    public forceTLS;
    public reactUiUrl;

    constructor() { }
}
